// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import styled from "styled-components";
import { connect } from "react-redux";
import * as actions from "../../modules/actions";
import * as selectors from "../../modules/selectors";
import type { TPLeague } from "../../modules/types/league";
import colors from '../../assets/css/colors';
import PlusBordered from '../../components/Icons/PlusBordered';
import MinusBordered from '../../components/Icons/MinusBordered';
import {
	OneColumnLayout,
	PageTitle,
	socialShare,
	AdsContainer,
	Ad,
	Tooltip,
	Label,
	ButtonSecondaryLink,
} from "../../components";
import { below } from "../../assets/css/media";
import Facebook from "../../components/Icons/Facebook";
import Twitter from "../../components/Icons/Twitter";
import SocialIcon from "../../components/Icons/SocialIcon";
import { leagueValidate } from "../../utils/FormValidations";
import LoadingSpinner from "../../components/LoadingSpinner";
import { delay } from '../../helpers/league';
import Tick from "../../components/Icons/Tick";
import { LeaguePin } from "./invites/leaguePin";
import EmailInviteForm from "./invites/emailInviteForm";
import { ButtonSocial } from "./invites/buttonSocial";
import { CopyToClipboard } from "./invites/copyToClipboard";

const InvitePageStyled = styled.div`
	box-shadow: 0px 0px 6px 3px #e4e4e4;
	margin: 1em 0;
	position: relative;
`;

const ButtonSecondaryStyled = styled(ButtonSecondaryLink)`
	width:60%;
	opacity: ${({ is_inactive }) => is_inactive ? '.3' : '1'};
`;

const InviteTypesWrapper = styled.div`
	max-width: 484px;
	margin: 0 auto;
	>div{
		padding-bottom: 2em;
	}
	.link-input {
		position: absolute;
		top: 0;
		z-index: -2;
	}
	${below.desktop`
		padding:20px;
	`};

`;

const ButtonSocialStyted = styled(ButtonSocial)`
	width:100%;
	background: white;
	border-right: none;
	> div {
		flex-basis: 15%;
	}
		.text{
			justify-content: flex-start;
			padding-left:0.5em ;
			color:${colors.darkGrey};
			font-weight: bold;
			border-top-right-radius: 6px;
			border-bottom-right-radius: 6px;
		}
	p {
		position: absolute;
		left: 80%;
		color: ${colors.nrlGreen};
		font-size: 19px;
		display: flex;
		align-items: baseline;
		> span {
			font-weight: 400;
			text-transform: none;
			margin-left: 3px;
		}

	}
`;

const InviteLeaguePinBlock = styled.div`
	background: white;
	border-bottom: 1px solid ${colors.darkGrey};

	${below.desktop`
		padding:20px;
	`};
`;
const FieldWithoutBoxShadow = styled(Field)`
`;


const LeaguePinTitleText = styled.div`
	text-align: center;
	font-size: 15px;
	font-weight: bold;
	line-height: 1.46;
	color: ${colors.darkGrey};
	padding-top: 2.5em;
`;

const LeaguePinInfoText = styled.div`
	text-align: center;
	font-size: 12px;
	line-height: 1.1;
	color: ${colors.darkGrey};
	padding: 1em;
	.code-input {
		border:none;
		margin-left: 5px;
		box-shadow: unset;
		color: ${colors.darkGrey};
		font-size: 12px;
		background: white;
		line-height: 1.1;
		pointer-events: none;
	}
`;

const SkipButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding-bottom: 2em;

`;
const EmailFields = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 1em;
	margin-bottom: 1em;
`;
const ControlButton = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	color:${colors.nrlDarkGreen};
	margin: 10px;
	display: ${({ is_visible }) => is_visible ? 'block' : 'none'};
	&:hover{
		background-color:${colors.lightGreen}
	}
`;
const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: center;
	&:last-child{

	}
`;

const InviteTypeLabel = styled.div`
	font-size: 15px;
	font-weight: bold;
	line-height: 1.46;
	color: ${colors.darkGrey};
	padding-top: 2.5em;
`;

const EmailFirstnameField = styled.div`
	width:55%;
	> div {
		display: flex;
		justify-content: space-between;
		align-items: center;
		> input{
			width:85%;
		}
	}
`;

const EmailEmailField = styled.div`
	width:40%;
`;

const EmailSentHeader = styled.h1`
	text-align: center;
	font-size: 20px;
	font-weight: 800;
`;

const InputStyled = styled(Field)`
	color: ${({ is_error }) => is_error ? colors.red : colors.darkGrey};
	font-weight: bold;
	font-size: 12px;
	height: 36px;
	border: 1px solid ${({ is_error }) => is_error ? colors.red : colors.lightGrey};
	background-color: #FFFFFF;
	width: 100%;
	box-shadow: 2px 0px 9px 2px #efeeee;
	padding-left: 1em;

	&:disabled {
		opacity: .5;
		margin-left: 1em;
	}

	::placeholder {
		color: ${({ is_error }) => is_error ? colors.red : colors.darkGrey};
	}
`;

const SocialIconStyled = styled(SocialIcon)`
	padding-bottom: 0.4em;
`;

type Props = {
	showDraftLeague: typeof actions.leagueDraft.showDraftLeague,
	inviteToDraftLeague: typeof actions.leagueDraft.inviteToDraftLeague,
	match: {
		params: {
			league_id: number,
		}
	},
	league_show: {
		error: string,
		league_id: number,
		is_pending: boolean,
	},
	regenerate_show: {
		error: string,
		is_pending: boolean,
		by_id: Object
	},
	league: TPLeague,
	submitting: Function,
}

type State = {
	email_field: Array<number>,
	display_emails: number,
	email_sent: string,
	disable_send: boolean,
	copied: boolean,
	linkCopied: boolean,
	regen_invites: [{
		firstname: string,
		email: string
	}]
};

class LeagueInviteComponent extends React.Component<Props, State> {
	hiddenInputCode: { current: null | HTMLInputElement };
	hiddenInputLink: { current: null | HTMLInputElement };
	state = {
		display_emails: 1,
		disable_send: true,
		email_sent: '',
		copied: false,
		linkCopied: false,
		regen_invites: []
	};

	constructor(props, state) {
		super(props, state);
		this.hiddenInputLink = React.createRef();
		this.hiddenInputCode = React.createRef();
		_.bindAll(this, [
			'handleEmailInviteSubmit',
			'onChangeEmail',
			'shareInvite',
			'toggleDisplayEmails',
			'copyCode',
			'copyLink',
		]);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		// window.ga('create', 'UA-XXXX-Y')
		// window.ga("send",{
		// 	hitType: 'event',
		// 	eventCategory: 'Test',
		// 	eventAction: 'Test',
		// 	eventLabel: 'Test Label'
		// });
		//
		// console.log(window.ga);
		const {
			match: {
				params: {
					league_id,
				},
			},
			showDraftLeague,
		} = this.props;

		showDraftLeague({ id: league_id });
	}

	componentDidUpdate(prev_props) {
		const {
			regenerate_show,
			league_show,
			league,
		} = this.props;

		// when this league is complete fetching
		if(prev_props.league_show.is_pending && !league_show.is_pending) {
			// check if it's a regen league
			if(league.regenerated_from !== 0) {
				// if regen leauge data is available
				if(league.regenerated_from in regenerate_show.by_id) {
					// populate
					const prev_league = regenerate_show.by_id[league.regenerated_from];
					this.setState({
						display_emails: prev_league.users.length,
						regen_invites: prev_league.users,
						disable_send: false
					});
				}
			}
		}
	}

	copyCode(e: any) {
		CopyToClipboard(this.hiddenInputCode).then(() => {
			this.setState({
				copied: true,
			}, this.hideMessage);
		});
	}

	copyLink(e: any) {
		CopyToClipboard(this.hiddenInputLink).then(() => {
			this.setState({
				linkCopied: true,
			}, this.hideMessage);
		});
	}

	hideMessage() {
		const THREE_SECONDS = 3000;
		delay(THREE_SECONDS).then(
			() => {
				this.setState({
					copied: false,
					linkCopied: false,
				});
			},
		);

	}

	shareInvite(sc_type) {

		const {
			match: {
				params: {
					league_id,
				},
			},
			league,

		} = this.props;
		const team_id = league.team_id ? league.team_id : null;
		const data = {
			sc_type: sc_type,
			share_type: 'league',
			league_id: league_id,
			league_name: league.name,
			team_id: team_id,
		};
		socialShare(data);
	}


	handleEmailInviteSubmit(api_params) {
		const {
			inviteToDraftLeague, match: {
				params: {
					league_id,
				},
			},
		} = this.props;
		inviteToDraftLeague({
			league_id: league_id,
			invites: api_params.invites,
		});
		this.setState({ email_sent: 'Email Sent!' });
	};

	toggleDisplayEmails(action) {
		const { display_emails } = this.state;
		const addend = action === 'add' ? 1 : -1;
		this.setState({ display_emails: display_emails + addend });
	}

	onChangeEmail({ currentTarget }) {
		const email = currentTarget.value;
		this.setState({ disable_send: email.length ? false : true });
	}


	get email_fields() {
		const { display_emails } = this.state;

		const email_fields = _.range(0, display_emails).map(item => (
			<EmailFields key={item}>
				<EmailEmailField>

					<Label htmlFor="firstname">First Name*</Label>
					<InputStyled
						name={'invites[' + item + '][firstname]'}
						type="text"
						required
						onChange={this.onChangeEmail}
						component="input"
					/>
				</EmailEmailField>
				<EmailFirstnameField>
					<Label htmlFor="email">Email*</Label>
					<div>
						<InputStyled
							required
							name={'invites[' + item + '][email]'}
							type="email"
							onChange={this.onChangeEmail}
							component="input"
							value='1'
						/>
						<Tooltip title={''}
						         description={'Invite friends to join your league via Email'}
						         show_on_left={false}/>
					</div>
				</EmailFirstnameField>


			</EmailFields>
		));

		return (
			<div>

				<InviteTypeLabel>
					Invite via email:
				</InviteTypeLabel>
				{email_fields}
				<ButtonsWrapper>
					<ControlButton
						onClick={() => this.toggleDisplayEmails('add')}
						is_visible={true}
					>
						<PlusBordered
							hover={colors.lightGreen}
							width={'28px'}
							height={'28px'}
						/>
					</ControlButton>
					<ControlButton
						onClick={() => this.toggleDisplayEmails('remove')}
						is_visible={this.state.display_emails > 1}
					>
						<MinusBordered
							width={'28px'}
							height={'28px'}
						/>
					</ControlButton>

				</ButtonsWrapper>
			</div>
		);
	}

	render() {
		const { league } = this.props;
		const { disable_send, email_sent } = this.state;
		const is_loading = this.props.league_show.is_pending;
		const link = `${window.location.origin}/draft/leagues/join/${league.code}`;
		return (
			<div>
				<AdsContainer>
					<Ad
						adUnit='invites'
						size='top'
					/>
				</AdsContainer>
				{!is_loading ? (
					<OneColumnLayout>
						<PageTitle>
							Invite people to join {league.name}
						</PageTitle>
						<InvitePageStyled>
							<InviteLeaguePinBlock>
								<LeaguePinTitleText>
									Great, now that you have joined this league,
									invite others to join.
								</LeaguePinTitleText>
								<LeaguePinInfoText>
									The invitation PIN for {league.name} is:
									<input
										type="text"
										className={'code-input'}
										ref={this.hiddenInputCode}
										defaultValue={league.code}/>
								</LeaguePinInfoText>
								<FieldWithoutBoxShadow
									label='League Pin'
									type='text'
									name='league_pin'
									placeholder='League Pin'
									component={LeaguePin}
									handleCopy={this.copyCode}
									show_success={this.state.copied}
									tooltip={{
										title: 'League PIN',
										description: 'Share your League PIN with ' +
										'others to allow them to join your league',
									}}
								/>
							</InviteLeaguePinBlock>


							<InviteTypesWrapper>
								<EmailInviteForm
									onSubmit={this.handleEmailInviteSubmit}
									email_fields={this.email_fields}
									disabled_submit={disable_send}
									invites={this.state.regen_invites}
								/>
								<EmailSentHeader>{email_sent}</EmailSentHeader>
								<div>
									<InviteTypeLabel>
										Invite via Social:
									</InviteTypeLabel>

									<ButtonSocialStyted onClick={() => this.shareInvite('fb')}>
										<div>
											<Facebook size="2" height={'1.5em'} width={'1.5em'}/>
										</div>
										<div className="text">Facebook</div>
									</ButtonSocialStyted>

									<ButtonSocialStyted onClick={() => this.shareInvite('tw')}>
										<div>
											<Twitter size="2" height={'1.5em'} width={'1.5em'}/>
										</div>
										<div className="text">Twitter</div>
									</ButtonSocialStyted>

									<ButtonSocialStyted
										onClick={this.copyLink}>
										<div>
											<SocialIconStyled size="2" height={'2em'}
											                  width={'2em'}/>
										</div>
										<div className="text">COPY LEAGUE LINK</div>
										{this.state.linkCopied ?
											<p>
												<Tick/>
												<span>Link copied!</span>
											</p>
											: null}
									</ButtonSocialStyted>
									<input
										type="text"
										className={'link-input'}
										ref={this.hiddenInputLink}
										defaultValue={link}/>

								</div>
								<SkipButtonWrapper>
									<ButtonSecondaryStyled
										to={`/league/${this.props.match.params.league_id}/team/pre-draft/`} // eslint-disable-line max-len
									>
										Skip this for now
									</ButtonSecondaryStyled>
								</SkipButtonWrapper>
							</InviteTypesWrapper>
						</InvitePageStyled>
					</OneColumnLayout>
				) : (<LoadingSpinner/>)}

				<AdsContainer>
					<Ad
						adUnit='invites'
						size='bottom'
					/>
				</AdsContainer>
			</div>
		);
	}
}

LeagueInviteComponent = reduxForm({
	form: 'league_invite',
	validate: leagueValidate,
})(LeagueInviteComponent);

const mapStateToProps = (state, props) => {
	return {
		regenerate_show: state.leagues.regenerate_show,
		league_show: state.leagues.show,
		user: selectors.getUser(state),
		league: selectors.leagueDraft.getLeague(state, props),
	};
};

const mapDispatchToProps = {
	inviteToDraftLeague: actions.leagueDraft.inviteToDraftLeague,
	showDraftLeague: actions.leagueDraft.showDraftLeague,
};

export const LeagueInvite = connect(
	mapStateToProps,
	mapDispatchToProps,
)(LeagueInviteComponent);

export default LeagueInvite;


// WEBPACK FOOTER //
// ./src/pages/league/Invite.js